export const getNormalizedVersion = (version: string): string => {
  if (!version) return '';

  return version
    .split('.')
    .map((part) => part.padStart(3, '0'))
    .join('');
};
